export default __webpack_public_path__ + "static/media/ig-post-3.baf7dfa6.jpeg";